import React from 'react';
import { P, Span } from '@tpr/core';
import styles from '../../../../cards.module.scss';
export var PhonePreview = React.memo(function (_a) {
    var _b = _a.label, label = _b === void 0 ? 'Phone' : _b, value = _a.value;
    return (React.createElement(React.Fragment, null,
        React.createElement(Span, { cfg: { lineHeight: 3 }, className: styles.styledAsH4 }, label),
        React.createElement(P, { "x-ms-format-detection": "none", className: styles.noMarginBottom }, value)));
});
//# sourceMappingURL=phonePreview.js.map